import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";

export const getUserAccount = createAsyncThunk(
  "userAccount/getUserAccount",
  async (params = {}, { rejectWithValue }) => {
    try {
      let { clientId, securityId,investmentId } = params;

      const query = new URLSearchParams();

      // clientId (array or single)
      if (Array.isArray(clientId) && clientId.length > 0) {
        query.append("clientId", clientId.join(","));
      } else if (!Array.isArray(clientId) && clientId) {
        query.append("clientId", clientId);
      }

      // securityId (array or single)
      if (Array.isArray(securityId) && securityId.length > 0) {
        query.append("productId", securityId.join(","));
      } else if (!Array.isArray(securityId) && securityId) {
        query.append("productId", securityId);
      }
     
      if(investmentId){
         query.append("investmentId", investmentId);
      }

       
      const queryString = query.toString();

      const url = queryString
        ? `/account/getUserAccount?${queryString}`
        : `/account/getUserAccount`;

      const response = await getMethod(url);
      const json = await response.json();
      return json;

    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch user account");
    }
  }
);



const initialState = {
  loading: false,
  error: null,
  success: false,
  docAccountdata: null,
};

const userAccountSlice = createSlice({
  name: "userAccount",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserAccount.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(getUserAccount.fulfilled, (state, action) => {
        state.loading = false;
        state.docAccountdata = action.payload?.data;
        state.success = true;
        state.error = null;
      })
      .addCase(getUserAccount.rejected, (state, action) => {
        state.loading = false;
        state.docAccountdata =null;
        state.error = action.payload || "Failed to fetch user account";
        state.success = false;
      });
  },
});

export default userAccountSlice.reducer;
